export function isDisabled(type) {
  return !['choice', 'multiplechoice'].includes(type)
}
